import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Call } from '@awaze/design-system.components.icon';
import styled from 'styled-components';
import { Popover, usePopover } from '@awaze/design-system.components.popover';
import { Stack } from '@awaze/design-system.components.stack';
import { Text } from '@awaze/design-system.components.text';
import { useEffect, useRef } from 'react';
import { breakpoints, MEDIA_QUERY_BREAKPOINTS, useWindowWidth, } from '@awaze/design-system.utils.react';
import { PopoverDropdownStyled } from '../navigation-item/navigation-item-with-popover';
import { NavigationItemStyled } from '../navigation-item/navigation-item.styles';
const PhoneIconStyled = styled(Call) `
  position: relative;
  top: 5px;

  margin: 0 12px;
  @media screen and (min-width: ${MEDIA_QUERY_BREAKPOINTS.mobile}px) {
    margin: 0 20px;
  }
`;
const PhoneIconMobileLink = styled.a `
  @media screen and (min-width: ${MEDIA_QUERY_BREAKPOINTS.mobile}px) {
    display: none;
  }
`;
const NavigationItemDesktop = styled(NavigationItemStyled) `
  @media screen and (max-width: ${MEDIA_QUERY_BREAKPOINTS.mobile - 1}px) {
    display: none;
  }
`;
export const PhoneIconComponent = ({ title, phoneNumber }) => {
    const wrapperRef = useRef(null);
    const { PopoverContainer, openPopover, closePopover, popoverProps, triggerProps, } = usePopover();
    const windowWidth = useWindowWidth();
    const isDesktop = windowWidth > breakpoints[1] - 1;
    const isTablet = windowWidth > breakpoints[0] - 1 && windowWidth < breakpoints[1];
    // Handle outside click on tablet
    useEffect(() => {
        if (!isTablet)
            return;
        const handleClickOutside = (event) => {
            if (wrapperRef.current &&
                !wrapperRef.current.contains(event.target)) {
                closePopover();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isTablet, closePopover]);
    const handleTabletClick = () => {
        if (isTablet)
            openPopover();
    };
    return (_jsxs(_Fragment, { children: [_jsx(NavigationItemStyled, { highlight: true, "aria-label": "promoted", children: _jsx(Stack, { align: "end", children: _jsx(PhoneIconMobileLink, { href: `tel:${phoneNumber}`, children: _jsx(PhoneIconStyled, { "data-testid": "responsive-header-phone-icon" }) }) }) }), _jsx(NavigationItemDesktop, { isChild: true, highlight: true, "aria-label": "promoted", children: _jsx(Stack, { align: "end", children: _jsx("div", { ref: wrapperRef, onClick: handleTabletClick, onKeyDown: handleTabletClick, onMouseOver: isDesktop ? openPopover : undefined, onMouseLeave: isDesktop ? closePopover : undefined, tabIndex: 0, ...triggerProps, children: _jsxs(PopoverContainer, { permanent: true, relativePosition: true, children: [_jsx(PhoneIconStyled, { "data-testid": "responsive-header-phone-icon" }), _jsx(PopoverDropdownStyled, { isOpen: popoverProps.popoverVisible, "aria-hidden": !popoverProps.popoverVisible, "data-testid": "popover-dropdown", children: _jsx(Popover, { enableHitarea: true, placement: "bottom", disableFlip: true, ...popoverProps, popoverVisible: true, boxConfig: { padding: 24 }, offset: { left: -40, top: 40 }, children: _jsxs(Stack, { spacing: 16, children: [_jsx(Text, { color: "ColorGrey900", children: title }), _jsx(Text, { children: phoneNumber })] }) }) })] }) }) }) })] }));
};
//# sourceMappingURL=phone-icon.js.map